export default "__VITE_ASSET__B2KyQYPX__"